import { render, staticRenderFns } from "./relationList.vue?vue&type=template&id=29b7cc38&scoped=true"
import script from "./relationList.vue?vue&type=script&lang=js"
export * from "./relationList.vue?vue&type=script&lang=js"
import style0 from "./relationList.vue?vue&type=style&index=0&id=29b7cc38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7cc38",
  null
  
)

export default component.exports